import { doFetch, doPostFetch, doDeleteFetch } from "./apiFetchHelper";
const API_URL = `/api/auth`;

function validateSession() {
  return doFetch(API_URL);
}

export function signIn(credentials) {
  return doPostFetch(API_URL, credentials);
}

export function signOut() {
  return doDeleteFetch(API_URL);
}

export function authByCvt(credentials) {
  return doPostFetch(`${API_URL}/identifyByCvt`, credentials);
}

export function getSsoAuthUrl() {
  return doPostFetch(`${API_URL}/getSsoAuthUrl`, {});
}

export function authBySsoToken(data) {
  return doPostFetch(`${API_URL}/sso`, data);
}

export function authBySlaToken(data) {
  return doPostFetch(`${API_URL}/sla`, data);
}

export default {
  signIn,
  signOut,
  validateSession,
  authByCvt,
  getSsoAuthUrl,
  authBySsoToken,
  authBySlaToken,
};
